import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { OcorrenciasService } from '../ocorrencias.service';
import { ComumService } from '../../comum/comum.service';
import { AuthService } from '../../auth/auth.service';
import { ReincidenciaOcorrencia } from '../../comum/modelos/reincidencia-ocorrencia';
import { CriterioReincidenciaOcorrencia } from '../../comum/modelos/criterio-reincidencia-ocorrencia';
import { UsuarioService } from '../../usuario/usuario.service';
import { Usuario } from '../../comum/modelos/usuario';
import { CookieService } from 'angular2-cookie';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ConfirmationService } from 'primeng/primeng';
import { RotinaService } from '../../rotina/rotina.service';

@Component({
    selector: 'app-reincidencia-ocorrencia',
    templateUrl: './reincidencia-ocorrencia.component.html',
    styleUrls: ['./reincidencia-ocorrencia.component.css']
})
export class ReincidenciaOcorrenciaComponent implements OnInit {

    @Input() idConfigOcorrenciaAuto: number;
    @Input() origem: string;
    @Output() reincidenciaOcorrenciaEvent: EventEmitter<ReincidenciaOcorrencia>;
    reincidenciaOcorrencia: ReincidenciaOcorrencia;
    criterios: CriterioReincidenciaOcorrencia[];
    usuarios: Usuario[];
    selecionados = false;
    ultimosDias: boolean;
    ultimasSemanas: boolean;
    ultimosMeses: boolean;
    rangeDatas: boolean;

    MODO: string;
    CADASTRAR = 'Cadastrar';
    ATUALIZAR = 'Atualizar';
    public statusCode: number;
    public loading = false;
    pt: any;
    dateFormat = 'dd/mm/yy';

    constructor (private _ocorrenciasService: OcorrenciasService,
        private _rotinaService: RotinaService,
        private _comumService: ComumService,
        public _authService: AuthService,
        private _cookieService: CookieService,
        private _usuarioService: UsuarioService,
        private confirmationService: ConfirmationService) {
        this.reincidenciaOcorrencia = new ReincidenciaOcorrencia();
        this.criterios = new Array<CriterioReincidenciaOcorrencia>();
        this.usuarios = new Array<Usuario>();
        this.reincidenciaOcorrenciaEvent = new EventEmitter<ReincidenciaOcorrencia>();
    }

    ngOnInit() {
        console.log(this.origem);
        this.loading = true;
        const self = this;
        self.pt = {
            firstDayOfWeek: 1,
            dayNames: ['domingo', 'segunda', 'ter\xE7a', 'quarta', 'quinta', 'sexta', 's\xE1bado'],
            dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 's\xE1b'],
            dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
            monthNames: ['janeiro', 'fevereiro', 'mar\xE7o', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro',
                'outubro', 'novembro', 'dezembro'],
            monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
            today: 'Hoje',
            clear: 'Apagar'
        };
        self._ocorrenciasService.obterReincidenciaOcorrenciaHttp(self.idConfigOcorrenciaAuto)
            .subscribe(reincidencia => {
                console.log(reincidencia);
                self.reincidenciaOcorrencia = reincidencia;
                self.reincidenciaOcorrencia.idConfigOcorrenciaAuto = self.idConfigOcorrenciaAuto;

                if (self.reincidenciaOcorrencia.dataInicioReferencia !== null
                    && self.reincidenciaOcorrencia.dataInicioReferencia !== undefined) {
                    self.reincidenciaOcorrencia.dataInicioReferencia = new Date(self.reincidenciaOcorrencia.dataInicioReferencia);
                    this.ultimosDias = false;
                    this.ultimasSemanas = false;
                    this.ultimosMeses = false;
                    this.rangeDatas = true;
                }
                if (self.reincidenciaOcorrencia.dataFimReferencia !== null && self.reincidenciaOcorrencia.dataFimReferencia !== undefined) {
                    self.reincidenciaOcorrencia.dataFimReferencia = new Date(self.reincidenciaOcorrencia.dataFimReferencia);
                    this.ultimosDias = false;
                    this.ultimasSemanas = false;
                    this.ultimosMeses = false;
                    this.rangeDatas = true;
                }
                if (self.reincidenciaOcorrencia.diasAte !== null && self.reincidenciaOcorrencia.diasAte !== undefined) {
                    this.ultimosDias = true;
                    this.ultimasSemanas = false;
                    this.ultimosMeses = false;
                    this.rangeDatas = false;
                }
                if (self.reincidenciaOcorrencia.semanasAte !== null && self.reincidenciaOcorrencia.semanasAte !== undefined) {
                    this.ultimosDias = false;
                    this.ultimasSemanas = true;
                    this.ultimosMeses = false;
                    this.rangeDatas = false;
                }
                if (self.reincidenciaOcorrencia.mesesAte !== null && self.reincidenciaOcorrencia.mesesAte !== undefined) {
                    this.ultimosDias = false;
                    this.ultimasSemanas = false;
                    this.ultimosMeses = true;
                    this.rangeDatas = false;
                }
                this._ocorrenciasService.obterAgendamentoOcorrenciaAutoHttp(this.idConfigOcorrenciaAuto).subscribe(configOcorrenciaAuto => {
                    forkJoin(self._rotinaService.obterCriteriosAvaliacaoRotinaClienteHttp(
                        configOcorrenciaAuto.rotinaCliente.idRotinaCliente),
                        self._usuarioService.obterUsuariosHttp(parseInt(this._cookieService.get('idCliente'), 10)))
                        .subscribe(([criterios, usuarios]) => {
                            self.usuarios = usuarios;
                            if (reincidencia.idReincidenciaOcorrencia === null || reincidencia.idReincidenciaOcorrencia === undefined) {
                                self.MODO = this.CADASTRAR;
                                for (const criterio of criterios) {
                                    const novoCriterioReincidencia = new CriterioReincidenciaOcorrencia();
                                    novoCriterioReincidencia.criterioAvaliacaoRotinaCliente = criterio;
                                    novoCriterioReincidencia.idCriterioAvaliacaoRotinaCliente = criterio.idCriterioAvaliacaoRotinaCliente;
                                    self.criterios.push(novoCriterioReincidencia);
                                }
                            } else {
                                self.MODO = this.ATUALIZAR;
                                self.reincidenciaOcorrencia = reincidencia;
                                self.reincidenciaOcorrencia.dataInicioReferencia = new Date(reincidencia.dataInicioReferencia);
                                self.reincidenciaOcorrencia.dataFimReferencia = new Date(reincidencia.dataFimReferencia);
                                for (const criterio of criterios) {
                                    const novoCriterioReincidencia = new CriterioReincidenciaOcorrencia();
                                    novoCriterioReincidencia.criterioAvaliacaoRotinaCliente = criterio;
                                    novoCriterioReincidencia.idReincidenciaOcorrencia
                                        = self.reincidenciaOcorrencia.idReincidenciaOcorrencia;
                                    novoCriterioReincidencia.idCriterioAvaliacaoRotinaCliente = criterio.idCriterioAvaliacaoRotinaCliente;
                                    for (const criterioReincidencia of reincidencia.criterios) {
                                        if (criterio.idCriterioAvaliacaoRotinaCliente
                                            === criterioReincidencia.idCriterioAvaliacaoRotinaCliente) {
                                            novoCriterioReincidencia.idCriterioReincidenciaOcorrencia
                                                = criterioReincidencia.idCriterioReincidenciaOcorrencia;
                                            novoCriterioReincidencia.selecionado = true;
                                            break;
                                        }
                                    }
                                    self.criterios.push(novoCriterioReincidencia);
                                }
                            }
                            self.loading = false;
                        });
                });
            });
    }

    selecionar(criterio: CriterioReincidenciaOcorrencia, event): void {
        criterio.selecionado = !criterio.selecionado;
        criterio.alterado = true;
    }

    selecionarTodos(): void {
        this.selecionados = !this.selecionados;
        this.criterios.forEach(criterio => {
            criterio.selecionado = this.selecionados;
            criterio.alterado = true;
        });
    }
    onSubmit(): void {
        if (!this.rangeDatas) {
            this.reincidenciaOcorrencia.dataInicioReferencia = null;
            this.reincidenciaOcorrencia.dataFimReferencia = null;
        }
        if (!this.ultimosDias) {
            this.reincidenciaOcorrencia.diasAte = null;
        }
        if (!this.ultimasSemanas) {
            this.reincidenciaOcorrencia.semanasAte = null;
        }
        if (!this.ultimosMeses) {
            this.reincidenciaOcorrencia.mesesAte = null;
        }
        if (!this.rangeDatas && !this.ultimosDias && !this.ultimasSemanas && !this.ultimosMeses) {
            this.confirmationService.confirm({
                rejectVisible: false,
                message: 'Favor informar um per\u00edodo',
                accept: () => { },
                reject: () => { }
            });

        }
        if (this.rangeDatas && (this.reincidenciaOcorrencia.dataInicioReferencia === undefined
            || this.reincidenciaOcorrencia.dataInicioReferencia === null
            || this.reincidenciaOcorrencia.dataFimReferencia === undefined
            || this.reincidenciaOcorrencia.dataFimReferencia === null)) {
            this.confirmationService.confirm({
                rejectVisible: false,
                message: 'Favor informar ambas as datas',
                accept: () => { },
                reject: () => { }
            });
        } else if (this.rangeDatas && (this.reincidenciaOcorrencia.dataInicioReferencia > this.reincidenciaOcorrencia.dataFimReferencia)) {
            this.confirmationService.confirm({
                rejectVisible: false,
                message: 'A data final tem de ser maior que a data inicial',
                accept: () => { },
                reject: () => { }
            });
        } else {
            let selecionado = false;
            for (const cri of this.criterios) {
                if (cri.selecionado) {
                    selecionado = true;
                    break;
                }
            }
            if (selecionado) {
                this.loading = true;
                const criteriosInsert = new Array<CriterioReincidenciaOcorrencia>();
                const criteriosRemove = new Array<CriterioReincidenciaOcorrencia>();
                this.criterios.forEach(criterio => {
                    if (!criterio.selecionado && criterio.idCriterioReincidenciaOcorrencia !== undefined && criterio.alterado) {
                        criteriosRemove.push(criterio);
                    } else if (criterio.selecionado && criterio.idCriterioReincidenciaOcorrencia === undefined
                        && criterio.alterado) {
                        criteriosInsert.push(criterio);
                    }
                });
                if (this.MODO === this.CADASTRAR) {
                    this._ocorrenciasService.cadastrarReincidenciaOcorrenciaHttp(this.reincidenciaOcorrencia)
                        .subscribe(reincidencia => {
                            const idReincidenciaOcorrencia = reincidencia.body.idReincidenciaOcorrencia;
                            criteriosInsert.forEach(criterioInsert => {
                                criterioInsert.idReincidenciaOcorrencia = idReincidenciaOcorrencia;
                            });
                            this._ocorrenciasService.cadastrarCriteriosReincidenciaOcorrenciaHttp(criteriosInsert)
                                .subscribe(response => {
                                    this.statusCode = response.status;
                                    this._comumService.evento.cadastro = true;
                                }, errorCode => {
                                    this.statusCode = errorCode;
                                });
                            this.loading = false;
                            this.reincidenciaOcorrenciaEvent.emit(reincidencia.body);
                        });
                } else {
                    this._ocorrenciasService.atualizarReincidenciaOcorrenciaHttp(this.reincidenciaOcorrencia)
                        .subscribe(reincidencia => {
                            if (criteriosRemove.length > 0) {
                                this._ocorrenciasService.removerCriteriosReincidenciaOcorrenciaHttp(criteriosRemove)
                                    .subscribe(response => {
                                        this.loading = false;
                                        this.statusCode = response.status;
                                        this._comumService.evento.cadastro = true;
                                    }, errorCode => {
                                        this.statusCode = errorCode;
                                    });
                            }
                            if (criteriosInsert.length > 0) {
                                this._ocorrenciasService.cadastrarCriteriosReincidenciaOcorrenciaHttp(criteriosInsert)
                                    .subscribe(response => {
                                        this.loading = false;
                                        this.statusCode = response.status;
                                        this._comumService.evento.cadastro = true;
                                    }, errorCode => {
                                        this.statusCode = errorCode;
                                    });
                            }
                            this.reincidenciaOcorrenciaEvent.emit(reincidencia.body);
                            this.loading = false;
                        });
                }
            } else {
                this.confirmationService.confirm({
                    rejectVisible: false,
                    message: 'Pelo menos um crit\u00e9rio deve ser selecionado',
                    accept: () => { },
                    reject: () => { }
                });
            }
        }
    }

    selecionarUltimosDias() {
        this.ultimosDias = true;
        this.ultimasSemanas = false;
        this.ultimosMeses = false;
        this.rangeDatas = false;
    }

    selecionarUltimasSemanas() {
        this.ultimosDias = false;
        this.ultimasSemanas = true;
        this.ultimosMeses = false;
        this.rangeDatas = false;
    }

    selecionarUltimosMeses() {
        this.ultimosDias = false;
        this.ultimasSemanas = false;
        this.ultimosMeses = true;
        this.rangeDatas = false;
    }

    selecionarRangeDatas() {
        this.ultimosDias = false;
        this.ultimasSemanas = false;
        this.ultimosMeses = false;
        this.rangeDatas = true;
    }
}





// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ocorrencias/reincidencia-ocorrencia/reincidencia-ocorrencia.component.ts